export default "__VITE_ASSET__CbiCZ5Vk__"